export const HUB_CARD_TEMPLATES = '/company/:companyId/:gameId/hub/card-templates'
